module.exports = __webpack_public_path__ + "static/media/dento_video.c3cc29d6.jpg";